// Translations
import {
  DESCRIPTION,
  TITLE,
} from '../translations/entrypoint-orchestrator-uncategorized.translations';

const ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS = {
  image: 'illustration_emptystates_no-results',
  description: DESCRIPTION,
  onTryAgainClick: (): null => null,
  title: TITLE,
};

export { ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS };
